module.exports = __webpack_public_path__ + "img/movie5.5aa27f3d.png";